import React from "react";

import "../assets/css/style.css"
import "../assets/css/reset.css"
import "../assets/css/responsive-leyouts.css"
import {deliveryType, selectIntervalAmount} from "../state/action";
import {useState} from "../state/useState";
import {Membership} from "./Membership";
import {Email} from "./Email";
import {NumberField} from "./NumberField";

export function VoucherData({deliveryTypes, selectedDeliveryType}) {


    let [state, dispatch] = useState();

    function render() {
        //console.log("selectedDeliveryType",selectedDeliveryType);
        if (selectedDeliveryType && selectedDeliveryType.index == 1) {
            return <Membership/>
        } else if (selectedDeliveryType && selectedDeliveryType.index == 2) {
            return <Email/>
        } else {
            return null;
        }
    }

    function isSelected(item) {
        return selectedDeliveryType && selectedDeliveryType.index == item.index
    }

    return <>
        <NumberField value={state.amount}
                     min={1}
                     step={200}
                     max={200}
                     dateOriginalTitle={"1 KM - 200 KM"}
                     placeholder={"Unesite iznos bona"}
                     onChange={(number) => dispatch(selectIntervalAmount(number))}/>
        <Email/>
    </>
}